/**
 * The strings of the one File row (piece 9; decisions 3010 to 3014), kept beside
 * the row's rules so the one lookup stays one table.
 * 🔨 Every message is a sentence; every pill is Title Case.
 */
export const FILE_ROW_STRINGS = {
  'file.verified': 'Verified',
  // 🔒 Decision 7420: the lock's word beside an encrypted file's name.
  'file.encrypted': 'Encrypted',
  'file.verified.byOn': 'Verified by {name} on {date}',
  'file.verified.on': 'Verified on {date}',
  'file.scan.clean': 'Clean',
  // 🔒 Decision 11301: the date the person gave the document at its upload, on the row's first line.
  'file.dated': 'Dated {date}',
  // 🔒 Decision 3014: the Possible duplicate question inside the upload window.
  'upload.duplicate.title': 'Possible duplicate',
  'upload.duplicate.byHash': 'A file with the same content is already filed on {record}.',
  'upload.duplicate.byName': 'A file with the same name is already filed on {record}.',
  'upload.duplicate.ask': 'Compare the two, then use the file already filed or upload yours anyway.',
  'upload.duplicate.existing': 'Already filed',
  'upload.duplicate.chosen': 'Your file',
  'upload.duplicate.uploadedBy': 'Uploaded {date} by {name}',
  'upload.duplicate.uploaded': 'Uploaded {date}',
  'upload.duplicate.reading': 'The file is loading.',
  'upload.duplicate.cannotDraw': 'This file cannot be drawn here.',
  'upload.duplicate.useExisting': 'Use the Existing File',
  'upload.duplicate.uploadAnyway': 'Upload Anyway',
} as const;
